import { define } from '../../define.js';
import { AlertDialog } from './alert-dialog.js';
export * from './alert-dialog.js';
define('alert-dialog', AlertDialog);
